export enum DataAddType {
  Cashier = 'Cashier',
  Customer = 'Customer',
  Item = 'Item',
  CustomerAlternateIDAndPIN = 'CustomerAlternateIDAndPIN',
  OnlineItem = 'OnlineItem',
  Transaction = 'Transaction',
  Tender = 'Tender',
  Coupon = 'Coupon',
  DatabarCoupon = 'DatabarCoupon',
  GiftCard = 'GiftCard',
  Giftreceipt = 'Giftreceipt',
  Group = 'Group',
  UserCredentials = 'UserCredentials',
  OrderServiceTransaction = 'OrderServiceTransaction',
  Undefined = 'Undefined',
  DriverLicense = 'DriverLicense',
}
